import React, { useEffect, useMemo } from "react";
import {
  Button,
  Modal,
  Select,
  DatePicker,
  Input,
  Popconfirm,
  ConfigProvider,
} from "antd";
import { useRef, useState } from "react";
import Draggable from "react-draggable";
import dayjs from "dayjs";
import { InputNumber } from "antd";
import { getDataDoc, updateDocDatabase } from "../database/index";
import { openErrorNotification } from "./Notifications/errorNotification";
import { useSelector } from "react-redux";
import { paddingTopIcon } from "@progress/kendo-svg-icons";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import {
  LeftOutlined,
  RightOutlined,
  UserOutlined,
  BookOutlined,
  CalendarOutlined,
  EditOutlined,
} from "@ant-design/icons";

import { openSuccesNotification } from "./Notifications/succesNotification";
import { calculeaza_medie_materie } from "../utils/calculare_medie";
import CatalogElev from "../Pages/Elevi/CatalogElev";
import "./ModalAddGradeModern.css";
const dateFormat = "DD/MM/YYYY";
const { TextArea } = Input;
function ModalAddGrade({
  open,
  setOpen,
  eleviData,
  elevId,
  setElevId,
  materii,
  gradesElevi,
  fullAcces,
  dupaTermen,
  scutiri,
  classData,
  classId,
  diriginteEmail,
}) {
  const draggleRef = useRef(null);
  const user = useSelector((state) => state.user);
  const [date, setDate] = useState(dayjs(new Date()));
  const [materieId, setMaterieId] = useState(null);
  const [tip, setTip] = useState("absenta");
  const [tezaNota, setTezaNota] = useState(null);
  const [inchidere, setInchidere] = useState(0);
  const [corigenta, setCorigenta] = useState();
  const [nota, setNota] = useState(null);
  const [loading, setLoading] = useState(false);
  const [comentariu, setComentariu] = useState("");
  const [teza, setTeza] = useState([]);
  const materiiRedux = useSelector((state) => state.materii);
  const clase = useSelector((state) => state.clase);
  const [examenFinal, setExamenFinal] = useState(null);
  const [examenFinalInt, setExamenFinalInt] = useState(null);
  const [examenFinalDec, setExamenFinalDec] = useState(null);
  const settings = useSelector((state) => state.settings);
  const [disabled, setDisabled] = useState(true);
  const [notare, setNotare] = useState(true);
  const [inchereMedie, setInchereMedie] = useState([]);
  const [showSuccessOverlay, setShowSuccessOverlay] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const memorizedMateriiLimited = useMemo(
    () => [materieId || "undefined"],
    [materieId]
  );

  const memorizedElevId = useMemo(() => elevId, [elevId]);
  // Funcție pentru a obține materiile disponibile pentru un elev
  const getMateriiDisponibile = (elevIdParam = elevId) => {
    const elevCurent = eleviData?.find((elev) => elev.id === elevIdParam);

    // Verifică dacă utilizatorul este diriginte și are permisiunea de a pune note la toate materiile

    // Dacă este diriginte cu permisiuni extinse, returnează toate materiile (fără duplicate)
    if (fullAcces) {
      const seen = new Set();
      return materii?.filter((ma) => {
        if (!ma?.id || seen.has(ma.id)) return false;
        seen.add(ma.id);
        return true;
      });
    }

    const seen = new Set();
    return materii?.filter((ma) => {
      // Dacă nu există materia sau a fost deja adăugată, nu o afișa
      if (!ma?.id || seen.has(ma.id)) return false;
      // Verifică dacă materia există în lista de materii normale a clasei
      const esteMateriaNormala = classData?.materii?.some(
        (classMa) =>
          classMa?.materie === ma.id &&
          classMa?.profesori?.find((p) => p === user.uid || p === user.id)
      );

      // Dacă este o materie normală a clasei
      if (esteMateriaNormala) {
        // Verifică dacă profesorul predă această materie normală
        const materieClasa = classData?.materii?.find(
          (classMa) => classMa?.materie === ma.id
        );
        const profesorPredaMateria = materieClasa?.profesori?.some(
          (p) => p === user.uid || p === user.id
        );

        if (profesorPredaMateria) {
          seen.add(ma.id);
          return true;
        }
        return false;
      }

      // Dacă nu e materie normală, atunci e specială
      // Verifică dacă elevul curent are această materie specială și profesorul predă la ea
      const materieSpecialaElev = elevCurent?.materiiSpecialitate?.find(
        (ms) => ms?.materie === ma.id
      );

      if (materieSpecialaElev) {
        const profesorPredaSpeciala = materieSpecialaElev?.profesori?.some(
          (p) => p === user.uid || p === user.id
        );

        if (profesorPredaSpeciala) {
          seen.add(ma.id);
          return true;
        }
      }

      // Verifică dacă este purtare și showPurtare este activat
      const estePurtareCuAcces =
        settings?.showPurtare === true &&
        ma?.numeMaterie?.toLowerCase().includes('purtare');

      if (estePurtareCuAcces) {
        seen.add(ma.id);
        return true;
      }

      return false;
    });
  };

  // Funcție pentru a obține elevii la care profesorul poate preda
  const getEleviAccesibili = () => {
    // Filtrează mai întâi elevii transferați/retrași
    const eleviFiltrati = eleviData?.filter((elev) => {
      return elev.retras !== true && elev.mutat !== true;
    }) || [];

    // Verifică dacă profesorul predă în materiile normale ale clasei
    if (fullAcces === true) {
      return eleviFiltrati;
    }
    const predaInClasa = classData?.materii?.some((m) =>
      (m?.profesori || []).includes(user.id || user.uid)
    );

    // Dacă predă în materii normale, poate naviga prin toți elevii
    if (predaInClasa) {
      return eleviFiltrati;
    }

    // Dacă nu predă în materii normale, doar elevii cu materii specializate
    return eleviFiltrati.filter((elev) => {
      const materiiSpecializate = elev?.materiiSpecialitate || [];
      return materiiSpecializate.some((ms) =>
        (ms?.profesori || []).includes(user.id || user.uid)
      );
    });
  };

  // Navigation functions
  const getCurrentStudentIndex = () => {
    const eleviAccesibili = getEleviAccesibili();
    return eleviAccesibili?.findIndex((student) => student.id === elevId);
  };

  const navigateToNextStudent = () => {
    const eleviAccesibili = getEleviAccesibili();
    const currentIndex = getCurrentStudentIndex();
    if (currentIndex < eleviAccesibili?.length - 1) {
      setElevId(eleviAccesibili[currentIndex + 1].id);
      resetForm();
    }
  };

  const navigateToPreviousStudent = () => {
    const eleviAccesibili = getEleviAccesibili();
    const currentIndex = getCurrentStudentIndex();
    if (currentIndex > 0) {
      setElevId(eleviAccesibili[currentIndex - 1].id);
      resetForm();
    }
  };

  const resetForm = () => {
    setNota(null);
    setExamenFinal(null);
    setExamenFinalInt(null);
    setExamenFinalDec(null);
    setCorigenta();
    setTezaNota(null);
    setComentariu("");
    // Nu resetez tip-ul pentru a păstra tipul de evaluare selectat
    setShowSuccessOverlay(false);
    setSuccessMessage("");
  };

  // Effect pentru a seta materia inițială când se schimbă elevul
  useEffect(() => {
    const materiiDisponibile = getMateriiDisponibile(elevId);
    if (materiiDisponibile?.length > 0 && !materieId) {
      setMaterieId(materiiDisponibile[0].id);
    } else if (materiiDisponibile?.length > 0 && materieId) {
      // Verifică dacă materia curent selectată este disponibilă pentru noul elev
      const materieDisponibila = materiiDisponibile?.find(
        (m) => m.id === materieId
      );
      if (!materieDisponibila) {
        // Dacă materia curentă nu este disponibilă, selectează prima disponibilă
        setMaterieId(materiiDisponibile[0].id);
      }
    }
  }, [elevId, materii, eleviData]);

  const getCurrentStudent = () => {
    return eleviData?.find((student) => student.id === elevId);
  };

  const getStudentInitials = (student) => {
    if (!student) return "?";
    const firstName = student.prenume || "";
    const lastName = student.numeDeFamilie || "";
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  };

  const digits_only = (string) =>
    [...string].every((c) => "0123456789".includes(c));
  const comentariii =
    process.env.REACT_APP_RESTRICT !== "enable"
      ? [
          {
            label: "Comentariu",
            value: "comentariu",
          },
        ]
      : [];
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });
  const showModal = () => {
    setOpen(true);
  };
  useEffect(() => {
    setNotare(
      materii?.find((ma) => ma.id === materieId)?.notare === undefined
        ? true
        : materii?.find((ma) => ma.id === materieId)?.notare
    );
  }, [materieId]);
  const addGrade = async () => {
    try {
      setLoading(true);
      if (!(materieId?.length > 0)) {
        setLoading(false);
        openErrorNotification("Selectează o materie");
        return;
      }

      if (tip === "comentariu" && !comentariu.length > 0) {
        setLoading(false);
        openErrorNotification("Nu poti trimite comentariu gol");
        return;
      }
      if (tip === "comentariu" && digits_only(comentariu)) {
        setLoading(false);
        openErrorNotification(
          "Nu poti trimite note in comentarii. Daca vrei sa trimiti un punctaj ca comentariu scrie si un text informativ"
        );
        return;
      }

      if (
        (gradesElevi[elevId]?.note || [])?.find(
          (n) => n.materieId === materieId && n.tip === "inchidere_medie"
        ) &&
        !(tip === "absenta" || tip === "comentariu")
      ) {
        setLoading(false);
        openErrorNotification("A fost deja inchisă media");
        return;
      }

      if (date.isValid() === false) {
        setLoading(false);
        openErrorNotification("Data este invalida");
        return;
      }
      let updateObj = {
        date: date.valueOf(),
        tip,
        id: Date.now() + "dd",
        timestamp: Date.now(),
        comentariu,
        materieId,
        authorId: user.uid,
        author: user.displayName,
        displayName: user.numeDeFamilie + " " + user.prenume,
        photoURL: user.photoLink || "",
      };
      if (tip === "nota") {
        if (!(nota > 0 && nota <= 10) && notare === true) {
          setLoading(false);
          openErrorNotification("Nota nu este valabila");
          return;
        }
        if (
          !(nota === "FB" || nota === "I" || nota === "B" || nota === "S") &&
          notare === false
        ) {
          setLoading(false);
          openErrorNotification("Nota nu este valabila");
          return;
        }
        updateObj["nota"] = nota;
      }
      if (tip === "examen_final") {
        const finalGrade =
          notare === true
            ? parseFloat(`${examenFinalInt || 0}.${examenFinalDec || 0}`)
            : examenFinal;
        if (!(finalGrade > 0 && finalGrade <= 10) && notare === true) {
          setLoading(false);
          openErrorNotification("Nota nu este valabila");
          return;
        }
        if (tip === "examen_final" && notare === false) {
          if (
            !(
              examenFinal === "FB" ||
              examenFinal === "B" ||
              examenFinal === "S" ||
              examenFinal === "I"
            )
          ) {
            setLoading(false);
            openErrorNotification("Nota nu este valabila");
            return;
          }
        }
        if (
          (gradesElevi[elevId]?.note || [])?.find(
            (n) => n.materieId === materieId && n.tip === "examen_final"
          )
        ) {
          setLoading(false);
          openErrorNotification("Examenul  a fost pus deja");
          return;
        }
        updateObj["examen_final"] =
          notare === true
            ? parseFloat(`${examenFinalInt || 0}.${examenFinalDec || 0}`)
            : examenFinal;
      }
      if (tip === "inchidere_medie") {
        updateObj["inchidere_medie"] = inchidere;

        if (
          (gradesElevi[elevId]?.note || [])?.filter(
            (n) =>
              n.materieId === materieId &&
              (n.tip === "nota" || n.tip === "examen_final")
          ).length <
            (classData.ore.filter(
              (o) =>
                o.materieId === materieId &&
                !materieId.includes("Teorie-") &&
                !materieId.includes("Tehnologia") &&
                !materieId.includes("Educa") &&
                !o?.rule?.includes("COUNT") &&
                !o?.rule?.includes("UNTIL")
            ).length || 1) +
              3 &&
          process.env.REACT_APP_NAME !==
            `Școala Gimnazială "Mihai Eminescu" Năsăud`
        ) {
          setLoading(false);
          openErrorNotification(
            "Note insuficiente, numar minim de note " +
              ((classData.ore.filter(
                (o) =>
                  o.materieId === materieId &&
                  !materieId.includes("Teorie-") &&
                  !materieId.includes("Tehnologia") &&
                  !materieId.includes("Educa") &&
                  !o?.rule?.includes("COUNT") &&
                  !o?.rule?.includes("UNTIL")
              ).length || 1) +
                3)
          );
          return;
        }

        if (
          (gradesElevi[elevId]?.note || [])?.filter(
            (n) =>
              n.materieId === materieId &&
              n.tip === "nota" &&
              n.delete === "waiting"
          ).length > 0
        ) {
          setLoading(false);
          openErrorNotification(
            "Note in curs de stergere! Nu se poate inchide media"
          );
          return;
        }
        if (
          inchidere === "nu exista note" ||
          inchidere === "Alege calificativ" ||
          inchidere === 0
        ) {
          setLoading(false);
          openErrorNotification("Nu poti inchide media, fară note in catalog");
          setOpen(false);
          return;
        }
      }
      if (tip === "corigenta") {
        updateObj["corigenta"] = corigenta;
      }
      await updateDocDatabase("catalog", elevId, {
        note: arrayUnion({
          ...updateObj,
        }),
      });
      let now = new Date();
      let onejan = new Date(now.getFullYear(), 0, 1);
      let week = Math.ceil(
        ((now.getTime() - onejan.getTime()) / 86400000 + onejan.getDay() + 1) /
          7
      );

      await updateDocDatabase("changelog", classData.id + "week" + week, {
        changelog: arrayUnion({
          author: user.displayName,
          time: Date.now(),
          classId,
          elevId,
          nota: updateObj,
        }),
      });

      let dataElev = await getDataDoc("elevi", elevId);

      // 📊 Adaugă în raportul elevului
      try {
        // Structura notei pentru raport
        const gradeInfo = {
          tip: updateObj.tip,
          nota: updateObj.nota || null,
          materieNume: materii?.find((ma) => ma.id === materieId)?.numeMaterie,
          data: updateObj.date,
          comentariu: updateObj.comentariu || "",
          profesor: updateObj.displayName || updateObj.author,
          timestamp: Date.now(),
          id: updateObj.id,
        };

        // Recipients: elev + părinți
        const recipients = [
          dataElev.adresaEmail,
          ...(dataElev.parintii || []),
        ].filter((email) => email);

        // Adaugă în documentul de raport al elevului
        await updateDocDatabase("studentReports", elevId, {
          elevId,
          studentName: `${dataElev.numeDeFamilie} ${dataElev.prenume}`,
          className: `${classData?.anClasa || ""}-${
            classData?.identificator || ""
          }`,
          recipients,
          pendingGrades: arrayUnion(gradeInfo),
          lastUpdate: Date.now(),
        });

        console.log(
          `📝 Notă adăugată în raportul pentru elevul: ${dataElev.numeDeFamilie} ${dataElev.prenume}`
        );
      } catch (error) {
        console.error("Eroare la adăugarea în raportul elevului:", error);
        // Nu oprește procesul dacă raportarea eșuează
      }

      //       if (tip === "comentariu") {
      //         await updateDocDatabase("mail", elevId + Date.now(), {
      //           to: [
      //             dataElev.adresaEmail,
      //             ...(dataElev.parintii || []),
      //             diriginteEmail,
      //           ],
      //           message: {
      //             subject:
      //               dataElev.numeDeFamilie +
      //               " " +
      //               dataElev.prenume +
      //               " a primit un comentariu de la " +
      //               user.displayName,

      //             html: `<code>
      //             <head>
      //  <style>
      //  table {
      //   font-family: arial, sans-serif;
      //   border-collapse: collapse;
      //   width: 100%;
      // }

      // td, th {
      //   border: 1px solid #dddddd;
      //   text-align: left;
      //   padding: 8px;
      // }

      // tr:nth-child(even) {
      //   background-color: #dddddd;
      // }
      //  </style>
      // </head>
      // <body>
      //             <table style="font-family: arial, sans-serif; border-collapse: collapse; width: 100%;">
      //             <tr>
      //               <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">Nume</th>
      //               <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">Materie</th>
      //               <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">Data</th>
      //               <th style="border: 1px solid #dddddd;text-align: left;padding: 8px;">Detalii</th>
      //             </tr>
      //             <tr>
      //               <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">${
      //                 dataElev.numeDeFamilie + " " + dataElev.prenume
      //               }</td>
      //               <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">${
      //                 materii?.find((ma) => ma.id === materieId).numeMaterie
      //               }</td>
      //               <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">${date
      //                 .toDate()
      //                 .toLocaleDateString("ro-RO")}</td>
      //               <td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">${comentariu}</td>
      //             </tr>

      //           </table>
      //           <br/>
      //           <br/>
      //           <br/>

      //           </body></code>`,
      //           },
      //         });
      //       }
      // Crearea mesajului de succes
      let message = "";
      const studentName =
        getCurrentStudent()?.numeDeFamilie + " " + getCurrentStudent()?.prenume;
      const subjectName = materii?.find((m) => m.id === materieId)?.numeMaterie;

      if (tip === "nota") {
        message = `Nota ${nota} adăugată pentru ${studentName} la ${subjectName}`;
      } else if (tip === "absenta") {
        message = `Absență adăugată pentru ${studentName} la ${subjectName}`;
      } else if (tip === "comentariu") {
        message = `Comentariu trimis pentru ${studentName} la ${subjectName}`;
      } else if (tip === "teza") {
        message = `Teză ${tezaNota} adăugată pentru ${studentName} la ${subjectName}`;
      } else if (tip === "examen_final") {
        const examGrade =
          notare === true
            ? parseFloat(`${examenFinalInt || 0}.${examenFinalDec || 0}`)
            : examenFinal;
        message = `Examen final ${examGrade} adăugat pentru ${studentName} la ${subjectName}`;
      } else if (tip === "inchidere_medie") {
        message = `Media ${inchidere} închisă pentru ${studentName} la ${subjectName}`;
      } else if (tip === "corigenta") {
        message = `Corigență ${corigenta} adăugată pentru ${studentName} la ${subjectName}`;
      }

      setSuccessMessage(message);
      setShowSuccessOverlay(true);

      // Ascunderea overlay-ului după 3 secunde
      setTimeout(() => {
        setShowSuccessOverlay(false);
        setSuccessMessage("");
        // Reset form pentru următoarea notă
        setNota(null);
        setExamenFinal(null);
        setExamenFinalInt(null);
        setExamenFinalDec(null);
        setCorigenta();
        setTezaNota(null);
        setComentariu("");
        // Nu resetez tip-ul pentru a păstra tipul de evaluare selectat
      }, 3000);

      setLoading(false);
    } catch (err) {
      openErrorNotification(err.message);
      setLoading(false);
    }
  };

  const handleOk = async (e) => {
    await addGrade();
    setInchidere(0);
    // Nu mai închide modalul
  };

  useEffect(() => {
    const teza = [];
    if (materii?.find((ma) => ma?.id === materieId)?.teza === true) {
      teza.push({ label: "Teza", value: "teza" });
    }
    setTeza(teza);
  }, [materieId]);
  useEffect(() => {
    if (!materieId) return;
    let array = (gradesElevi[elevId]?.note || [])
      ?.filter((n) => n.materieId === materieId)
      .map((el) => {
        return { label: el.nota, value: el.nota };
      });

    let uniquearray = [];
    array?.forEach((element) => {
      if (uniquearray?.find((el) => el.value === element.value) === undefined) {
        uniquearray.push(element);
      }
    });

    setInchereMedie(uniquearray);
    const calificative = {
      FB: 1,
      B: 2,
      S: 3,
      I: 4,
    };
    let freq = {};
    let notaFinala = 0,
      frv = 0;
    if (notare === false) {
      notaFinala = "Alege calificativ";
    } else {
      notaFinala = calculeaza_medie_materie(
        gradesElevi[elevId]?.note,
        materii?.find((ma) => ma.id === materieId),
        scutiri[elevId]
      ).medie;
    }

    setInchidere(notaFinala || 0);
  }, [elevId, gradesElevi, materieId, materii, notare, tip]);
  const currentStudent = getCurrentStudent();
  const currentIndex = getCurrentStudentIndex();
  const eleviAccesibili = getEleviAccesibili();
  const isFirstStudent = currentIndex === 0;
  const isLastStudent = currentIndex === eleviAccesibili?.length - 1;

  // Verifică dacă profesorul are acces la purtare doar prin showPurtare (nu este diriginte)
  const estePurtare = materii?.find((ma) => ma?.id === materieId)?.numeMaterie?.toLowerCase().includes('purtare');
  const esteProfesorPurtare = classData?.materii?.find((m) => m.materie === materieId)?.profesori?.includes(user.id || user.uid);
  const esteDiriginte = (user.id === classData?.diriginte || user.uid === classData?.diriginte ||
                         user.id === classData?.diriginte_step || user.uid === classData?.diriginte_step);
  const areAccesDoarPrinShowPurtare = estePurtare && !esteProfesorPurtare && !esteDiriginte && settings?.showPurtare === true;

  const gradeTypes = [
    { key: "absenta", label: "Absență", color: "#ff4d4f" },
    { key: "nota", label: "Notă", color: "#52c41a", show: !areAccesDoarPrinShowPurtare },
    {
      key: "teza",
      label: "Teză",
      color: "#1890ff",
      show: !areAccesDoarPrinShowPurtare && materii?.find((ma) => ma?.id === materieId)?.teza === true,
    },
    {
      key: "examen_final",
      label: "Examen Final",
      color: "#003d82",
      show: !areAccesDoarPrinShowPurtare && new Date() >= new Date("2026-05-01"),
    },
    {
      key: "inchidere_medie",
      label: "Închide Media",
      color: "#faad14",
      show: !areAccesDoarPrinShowPurtare && new Date() >= new Date("2026-05-01"),
    },
    {
      key: "corigenta",
      label: "Corigenta",
      color: "#fa8c16",
      show: !areAccesDoarPrinShowPurtare && new Date() >= new Date("2026-05-01"),
    },
    ...(!areAccesDoarPrinShowPurtare ? comentariii.map((c) => ({
      key: c.value,
      label: c.label,
      color: "#13c2c2",
    })) : []),
  ].filter((type) => type.show !== false);

  const handleCancel = () => {
    resetForm();
    setOpen(false);
  };

  return (
    <div>
      <Modal
        className="modern-add-grade-modal"
        confirmLoading={loading}
        width={window.innerWidth <= 768 ? "100vw" : 700}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <EditOutlined />
            Adaugă în Catalog
          </div>
        }
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
            className="modal-action-btn"
          >
            Anulează
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
            className="modal-action-btn modal-primary-btn"
          >
            Adaugă {tip}
          </Button>,
        ]}
      >
        {/* Success Overlay */}
        {showSuccessOverlay && (
          <div className="success-overlay">
            <div className="success-content">
              <div className="success-checkmark">✓</div>
              <div className="success-message">{successMessage}</div>
            </div>
          </div>
        )}

        {/* Student Navigation */}
        <div className="student-navigation">
          <Button
            className="nav-button"
            icon={<LeftOutlined />}
            onClick={navigateToPreviousStudent}
            disabled={isFirstStudent}
          />
          <div className="student-info">
            <div className="student-name">
              {currentStudent
                ? `${currentStudent.numeDeFamilie} ${currentStudent.initiala} ${currentStudent.prenume}`
                : "Selectează elev"}
            </div>
            <div className="student-counter">
              {currentIndex + 1} din {eleviAccesibili?.length} elevi
            </div>
          </div>
          <Button
            className="nav-button"
            icon={<RightOutlined />}
            onClick={navigateToNextStudent}
            disabled={isLastStudent}
          />
        </div>

        {/* Student Preview */}
        {currentStudent && (
          <div className="student-preview">
            <div className="preview-header">
              <div className="student-avatar">
                {getStudentInitials(currentStudent)}
              </div>
              <div className="student-details">
                <div className="student-full-name">
                  {currentStudent.numeDeFamilie} {currentStudent.prenume}
                </div>
                <div className="student-class-info">
                  Clasa {classData?.anClasa}-{classData?.identificator}
                </div>
              </div>
            </div>

            <div className="quick-stats">
              <div className="stat-item">
                <div className="stat-number">
                  {
                    (gradesElevi[elevId]?.note || []).filter(
                      (n) => n.materieId === materieId && n.tip === "absenta"
                    ).length
                  }
                </div>
                <div className="stat-label">Total absențe</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">
                  {
                    (gradesElevi[elevId]?.note || []).filter(
                      (n) =>
                        n.materieId === materieId &&
                        (n.tip === "nota" || n.tip === "teza")
                    ).length
                  }
                </div>
                <div className="stat-label">Nr. note</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">
                  {(() => {
                    const lastGrade = (gradesElevi[elevId]?.note || [])
                      .filter(
                        (n) =>
                          n.materieId === materieId &&
                          (n.tip === "nota" || n.tip === "teza")
                      )
                      .sort((a, b) => b.date - a.date)[0];

                    if (!lastGrade) return "Niciodată";

                    const daysSince = Math.floor(
                      (Date.now() - lastGrade.date) / (1000 * 60 * 60 * 24)
                    );
                    return daysSince === 0 ? "Astăzi" : `${daysSince} zile`;
                  })()}
                </div>
                <div className="stat-label">Ultima notă</div>
              </div>
            </div>
          </div>
        )}

        {/* Subject Selection */}
        <div className="subject-selection">
          <div className="section-title">
            <div className="section-icon">
              <BookOutlined />
            </div>
            Materie
          </div>
          <Select
            className="modern-input"
            style={{ width: "100%" }}
            value={materieId}
            onChange={(e, data) => {
              setMaterieId(e);
            }}
            options={getMateriiDisponibile()?.map((ma) => {
              return { label: ma?.numeMaterie, value: ma?.id };
            })}
          />
        </div>

        {/* Current Student's Catalog Preview */}
        <div style={{ marginBottom: "20px" }}>
          <CatalogElev
            materiiLimited={[materieId || "undefined"]}
            elevIdPassed={elevId}
            open={open}
          />
        </div>

        {/* Grade Entry Section */}
        <div className="grade-entry-section">
          <div className="section-title">
            <div className="section-icon">📝</div>
            Tip evaluare
          </div>

          <div className="grade-type-tabs">
            {gradeTypes.map((type) => (
              <Button
                key={type.key}
                className={`grade-type-tab ${tip === type.key ? "active" : ""}`}
                onClick={() => setTip(type.key)}
                style={{
                  borderColor: type.color,
                  color: tip === type.key ? "#fff" : type.color,
                  backgroundColor:
                    tip === type.key ? type.color : "transparent",
                }}
              >
                {type.label}
              </Button>
            ))}
          </div>

          <div className="grade-input-container">
            {tip === "nota" && notare === true && (
              <div className="grade-input-wrapper">
                <div className="grade-input-label">Nota:</div>
                <div className="grade-buttons-grid">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((grade) => {
                    const getGradeColor = (gradeValue) => {
                      if (gradeValue <= 4) return "#ff4d4f"; // Roșu pentru 1-4 (insuficient)
                      if (gradeValue <= 6) return "#fa8c16"; // Portocaliu pentru 5-6 (satisfăcător)
                      if (gradeValue <= 7) return "#faad14"; // Galben pentru 7 (bine)
                      if (gradeValue <= 9) return "#52c41a"; // Verde pentru 8-9 (foarte bine)
                      return "#1890ff"; // Albastru pentru 10 (excelent)
                    };

                    const gradeColor = getGradeColor(grade);

                    return (
                      <Button
                        key={grade}
                        className={`grade-button performance-grade ${
                          nota === grade ? "selected" : ""
                        }`}
                        onClick={() => setNota(grade)}
                        style={{
                          backgroundColor:
                            nota === grade ? gradeColor : "transparent",
                          borderColor: gradeColor,
                          color: nota === grade ? "#fff" : gradeColor,
                        }}
                      >
                        {grade}
                      </Button>
                    );
                  })}
                </div>
              </div>
            )}

            {tip === "nota" && notare === false && (
              <div className="grade-input-wrapper">
                <div className="grade-input-label">Calificativ:</div>
                <div className="grade-buttons-grid">
                  {[
                    { value: "FB", label: "Foarte Bine", color: "#52c41a" },
                    { value: "B", label: "Bine", color: "#1890ff" },
                    { value: "S", label: "Suficient", color: "#faad14" },
                    { value: "I", label: "Insuficient", color: "#ff7875" },
                  ].map((qual) => (
                    <Button
                      key={qual.value}
                      className={`grade-button ${
                        nota === qual.value ? "selected" : ""
                      }`}
                      onClick={() => setNota(qual.value)}
                      style={{
                        backgroundColor:
                          nota === qual.value ? qual.color : "transparent",
                        borderColor: qual.color,
                        color: nota === qual.value ? "#fff" : qual.color,
                      }}
                    >
                      {qual.label}
                    </Button>
                  ))}
                </div>
              </div>
            )}

            {tip === "teza" && (
              <div className="grade-input-wrapper">
                <div className="grade-input-label">Teză:</div>
                <InputNumber
                  className="modern-input grade-input"
                  min={1}
                  max={10}
                  value={tezaNota}
                  placeholder="Nota la teză (1-10)"
                  onChange={(value) => {
                    setTezaNota(value);
                  }}
                />
              </div>
            )}

            {tip === "corigenta" && notare === false && (
              <div className="grade-input-wrapper">
                <div className="grade-input-label">Corigență:</div>
                <Select
                  className="modern-input grade-input"
                  placeholder="Selectează calificativul"
                  value={corigenta}
                  onChange={(e, data) => {
                    setCorigenta(e);
                  }}
                  options={[
                    { label: "Foarte Bine", value: "FB" },
                    { label: "Bine", value: "B" },
                    { label: "Suficient", value: "S" },
                    { label: "Insuficient", value: "I" },
                  ]}
                />
              </div>
            )}

            {tip === "corigenta" && notare !== false && (
              <div className="grade-input-wrapper">
                <div className="grade-input-label">Corigență:</div>
                <InputNumber
                  className="modern-input grade-input"
                  min={1}
                  max={10}
                  value={corigenta}
                  placeholder="Nota la corigență (1-10)"
                  onChange={(value) => {
                    setCorigenta(value);
                  }}
                />
              </div>
            )}

            {tip === "inchidere_medie" && notare === false && (
              <div className="grade-input-wrapper">
                <div className="grade-input-label">Media:</div>
                <Select
                  className="modern-input grade-input"
                  placeholder="Selectează calificativul"
                  value={inchidere}
                  onChange={(e, data) => {
                    setInchidere(e);
                  }}
                  options={[
                    { label: "Foarte Bine", value: "FB" },
                    { label: "Bine", value: "B" },
                    { label: "Suficient", value: "S" },
                    { label: "Insuficient", value: "I" },
                  ]}
                />
              </div>
            )}

            {tip === "inchidere_medie" &&
              materii
                ?.find((m) => m.id === materieId)
                ?.numeMaterie?.includes("Purtare") &&
              notare === true && (
                <div className="grade-input-wrapper">
                  <div className="grade-input-label">Media:</div>
                  <InputNumber
                    className="modern-input grade-input"
                    min={1}
                    max={10}
                    value={inchidere}
                    placeholder="Media finală"
                    onChange={(value) => {
                      setInchidere(value);
                    }}
                  />
                </div>
              )}

            {tip === "examen_final" && notare === true && (
              <div className="grade-input-wrapper">
                <div className="grade-input-label">Examen:</div>
                <div className="exam-grade-inputs">
                  <InputNumber
                    className="modern-input exam-int-input"
                    min={1}
                    max={10}
                    value={examenFinalInt}
                    placeholder="0"
                    onChange={(value) => {
                      setExamenFinalInt(value);
                    }}
                  />
                  <span className="exam-decimal-separator">.</span>
                  <InputNumber
                    className="modern-input exam-dec-input"
                    min={0}
                    max={99}
                    value={examenFinalDec}
                    placeholder="00"
                    onChange={(value) => {
                      setExamenFinalDec(value);
                    }}
                  />
                </div>
              </div>
            )}

            {tip === "examen_final" && notare === false && (
              <div className="grade-input-wrapper">
                <div className="grade-input-label">Examen:</div>
                <Select
                  className="modern-input grade-input"
                  placeholder="Selectează calificativul"
                  value={examenFinal}
                  options={[
                    { value: "FB", label: "Foarte Bine" },
                    { value: "B", label: "Bine" },
                    { label: "Suficient", value: "S" },
                    { label: "Insuficient", value: "I" },
                  ]}
                  onChange={(e) => {
                    setExamenFinal(e);
                  }}
                />
              </div>
            )}
          </div>
        </div>

        {/* Date Section */}
        <div className="date-section">
          <div className="section-title">
            <div className="section-icon">
              <CalendarOutlined />
            </div>
            Data
          </div>

          <div className="date-input-wrapper">
            <ConfigProvider
              theme={{
                components: {
                  DatePicker: {
                    cellWidth: 60,
                    cellHeight: 50,
                    withoutTimeCellHeight: 50,
                    textHeight: 50,
                    inputFontSize: 16,
                  },
                },
              }}
            >
              <DatePicker
                className="modern-input"
                placeholder="Selectează data"
                format={dateFormat}
                disabledDate={(current) => {
                  const isOverLimit = (date) => {
                    const today = dayjs();
                    const diffInDays = today.diff(date, "day");
                    const isFuture = dayjs(date).isAfter(today, "day");

                    // Obține clasa curentă din Redux
                    const currentClass = clase.find((c) => c.id === classId);

                    // Obține limita de zile în funcție de tipul de intrare
                    let daysLimit = 21; // default

                    if (tip === "nota") {
                      daysLimit =
                        currentClass?.permisiuni?.zileInapoiNote || 21;
                    } else if (tip === "absenta") {
                      daysLimit =
                        currentClass?.permisiuni?.zileInapoiAbsente || 21;
                    }

                    return diffInDays > daysLimit || isFuture;
                  };
                  return (
                    current &&
                    (current.day() === 0 ||
                      current.day() === 6 ||
                      (isOverLimit(current) &&
                        user?.type !== "admin" &&
                        fullAcces !== true &&
                        dupaTermen !== true &&
                        settings?.treiSapt !== true &&
                        user?.treiSapt !== true))
                  );
                }}
                value={dayjs(date, dateFormat)}
                onChange={(_, data) => {
                  setDate(dayjs(data, dateFormat));
                }}
              />
            </ConfigProvider>
          </div>

          {/* Existing grades for selected date */}
          {(() => {
            const selectedDate = date.format("DD/MM/YYYY");
            const existingGrades = (gradesElevi[elevId]?.note || []).filter(
              (n) => {
                const gradeDate = dayjs(n.date).format("DD/MM/YYYY");
                return gradeDate === selectedDate && n.materieId === materieId;
              }
            );

            if (existingGrades.length > 0) {
              return (
                <div className="existing-grades-alert">
                  <div className="alert-title">
                    Note existente pentru {selectedDate}:
                  </div>
                  <div className="existing-grades-list">
                    {existingGrades.map((grade, index) => (
                      <div key={index} className="existing-grade-item">
                        <span className="grade-type">
                          {grade.tip === "nota"
                            ? "Notă"
                            : grade.tip === "absenta"
                            ? "Absență"
                            : grade.tip}
                        </span>
                        {grade.nota && (
                          <span className="grade-value">: {grade.nota}</span>
                        )}
                        {grade.comentariu && (
                          <span className="grade-comment">
                            {" "}
                            - {grade.comentariu}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            }
            return null;
          })()}
        </div>

        {/* Comment Section */}
        <div className="comment-section">
          <div className="section-title">
            <div className="section-icon">💬</div>
            Comentariu (opțional)
          </div>

          <TextArea
            className="modern-input"
            placeholder="Adaugă un comentariu (opțional)..."
            rows={3}
            value={comentariu}
            onChange={(e) => {
              setComentariu(e.target.value);
            }}
          />
        </div>

        {/* Confirmation Message */}
        <div className="confirmation-message">
          <div className="confirmation-text">Urmează să adaugi: {tip}</div>
          <div className="confirmation-details">
            Pentru elevul {currentStudent?.numeDeFamilie}{" "}
            {currentStudent?.prenume} la materia{" "}
            {materii?.find((m) => m.id === materieId)?.numeMaterie}
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default ModalAddGrade;
